module.exports = __webpack_public_path__ + "img/news8.0fab613a.png";